import React, { useContext } from 'react';
import { ChartWrapper, Main } from 'Benchmarks/Benchmarks.styles';
import {
	AnalysisWrapper,
	AnalysisWrapper2,
	TableBody,
	TableCellChart,
	TableCellGroup,
	TableCellMax,
	TableCellMin,
	TableCellPeerCount,
	TableContainer,
	TableHead,
	ChartWrapper2,
	TableRow,
	ProcurementChartWrapper,
} from 'Benchmarks/components/BenchmarkContainer/BenchmarkContainer.styles';
import ChartLegend from '../Components/ChartLegend/ChartLegend';
import { procurementMetricsContext } from '../Context/ProcurementMetricsContextProvider';
import ProcurementFilters from '../ProcurementFilters/ProcurementFilters';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import CategoryHierarchy from '../Components/CategoryHierarchy/CategoryHierarchy';
import { Content } from '../Components/CategoryHierarchy/CategoryHierarchy.styles';

const ProcurementMetricsNumerical = () => {
	const { procurementMetricsNumericalData, loading, onToggle1 } = useContext(
		procurementMetricsContext
	);

	const { isLoading, hierarchyData, onExpand, onToggle } = useContext(
		procurementMetricsContext
	);

	return (
		<Main>
			<ChartWrapper2>
				<ProcurementFilters />
				<AnalysisWrapper2 index="0">
					<TableContainer>
						<TableHead>
							<TableRow>
								<TableCellGroup />
								<TableCellPeerCount />
								<TableCellMin title="Lower end of interquartile range">
									Low End
								</TableCellMin>
								<TableCellChart>
									<ChartLegend />
								</TableCellChart>
								<TableCellMax title="Higher end of interquartile range">
									High End
								</TableCellMax>
							</TableRow>
						</TableHead>
						<TableBody>
							<CategoryHierarchy
								data={procurementMetricsNumericalData}
								showClassifications={false}
								showToggleButton={true}
								onExpand={() => {}}
								onToggle={onToggle1}
								isFirstTab={true}
							/>

							{loading && (
								<TableRow>
									<TableCellGroup />
									<TableCellPeerCount />
									<TableCellMin>
										<Content>
											<ApLoaderDefault />
										</Content>
									</TableCellMin>
									<TableCellChart />
									<TableCellMax />
								</TableRow>
							)}
						</TableBody>
					</TableContainer>
				</AnalysisWrapper2>
				<ProcurementChartWrapper>
					{!isLoading ? (
						hierarchyData.length > 0 ? (
							<AnalysisWrapper2 index="0" isScroll isExpanded>
								<TableContainer>
									<TableHead>
										<TableRow>
											<TableCellGroup
												as="th"
												colSpan={2}
												style={{
													whiteSpace: 'normal',
													textAlign: 'left',
													fontWeight: 'bold',
												}}
											>
												% Active suppliers accounting for 80% spend
											</TableCellGroup>
											<TableCellMin title="Lower end of interquartile range">
												Low End(%)
											</TableCellMin>
											<TableCellChart>
												<ChartLegend />
											</TableCellChart>
											<TableCellMax title="Higher end of interquartile range">
												High End(%)
											</TableCellMax>
										</TableRow>
									</TableHead>
									<TableBody>
										<CategoryHierarchy
											data={hierarchyData}
											showClassifications={false}
											showToggleButton={true}
											onExpand={onExpand}
											onToggle={onToggle}
										/>
									</TableBody>
								</TableContainer>
							</AnalysisWrapper2>
						) : (
							<>No data available</>
						)
					) : (
						<div
							style={{
								marginTop: '14%',
							}}
						>
							<ApLoaderDefault loaderText={() => <ApLoaderText />} />
						</div>
					)}
				</ProcurementChartWrapper>
			</ChartWrapper2>
		</Main>
	);
};

export default ProcurementMetricsNumerical;
